import React from "react";
import { useForm } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import { Grid, TextField, Button } from "@mui/material";
import { useLanguageContext } from "../../Context/LanguageContext";
import access_controlActions from "../../Actions/Access_ControlActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  paper: {
    width: "500px",
    maxWidth: "100%",
    margin: "20px auto",
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
}));

const labelStyle = {
  fontSize: "14px",
  backgroundColor: "white",
};

const CheckListLoginUser = () => {
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const classes = useStyles();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    setGlobalSpinner(true);

    access_controlActions.login(
      {
        username: data.username.trim(),
        password: data.password,
        language: language,
        // OrganisationId: 0,
        IsPublicWebsite: true,
      },
      false
    );
  };

  return (
    <div className={`${classes.paper} card`}>
      <div className="text-center">
        <h3>{localization.welcome}</h3>
      </div>
      <form
        className={classes.root}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              error={!!errors.username}
              id="username"
              label={localization.usernamePlaceholder}
              fullWidth
              helperText={errors.username?.message}
              variant="outlined"
              InputLabelProps={{ style: labelStyle }}
              {...register("username", {
                required: localization.usernameRequired,
              })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="password"
              error={!!errors.password}
              id="password"
              label={localization.passwortPlaceholder}
              fullWidth
              helperText={errors.password?.message}
              variant="outlined"
              InputLabelProps={{ style: labelStyle }}
              {...register("password", {
                required: localization.passwordRequired,
              })}
            />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" color="primary" type="submit">
              {localization.loginButton}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default CheckListLoginUser;
